import { BCMSValidate ,BCMSCurrency} from "@bcm-dev/bcms-vite";
import React, { useEffect, useState } from "react";
import { SVGAsset } from "res";
import UITextInput from "../UITextInput";
import "./styles.css";

/**
 * @function UIAmountInput 
 * @param {STRING} value - Allows to set the value of the text input. 
 * @param {STRING} onChange - Event handler that allows the input to change it’s value when someone is typing in it. 
 * @param {STRING} placeholder - Allows us to set a placeholder value/text that gets replaced when clicked into.
 * @returns {React.Component}
 * @example
 * <UIAmountInput value="0.00" onChange={e => {handleChange(e)}}/>
 */
 export default function UIAmountInput(props) {
  const placeholder = props.placeholder ?? "";
  
  const [ state, setState ] = useState({ "input" : props.value ?? "", "close" : false });
  
  const onChange = (value, evt) => {
    let newValue = BCMSValidate.isNumber(value) || value === "" ? value : state.input;

    // This checks the number of decimal places, if there are more than two
    // Then format the number to only have 2 decimals
    if(newValue.indexOf(".") !== -1 && newValue.split(".")[1].length > 2) {
      newValue = parseFloat(newValue).toFixed(2);
    }

    setState({ 
      "input" : newValue, 
      "close" : value.length > 0 
    });
    if(props.onChange instanceof Function) {
        props.onChange(newValue, evt);
    }
  };
 const onFocus =(value,evt)=>{
  let newValue = BCMSCurrency.init(value).amount;
  setState({ 
    "input" : newValue, 
    "close" : value.length > 0
  });
      if(props.onFocus instanceof Function) {
        props.onFocus(newValue, evt);
    }
 }
 const onBlur =(value,evt)=>{
  let newValue = BCMSCurrency.init(value).format({style:"decimal"});
  setState({ 
    "input" : newValue, 
    "close" : value.length > 0 
  });
      if(props.onBlur instanceof Function) {
        props.onBlur(newValue, evt);
    }
 }
  // Added useEffect to reset state when the props.value is either undefined or is an empty string
  useEffect(() => {
    const defaultState = { "input" : "", "close" : false };
    if((props.value === undefined || props.value === "") && state !== defaultState) {
      setState(defaultState);
    }
    else {
      setState({ "input" : props.value, "close" : true });
    }
  }, [ props.value ]);

  return (
      <div className="ui-amount-input">
          <div className="ui-amount-input-container">
              <UITextInput placeholder={placeholder} value={ state.input }onFocus={onFocus} onBlur={onBlur} onChange={ onChange } dataPoint={props.dataPoint?props.dataPoint+"_input":"" }onClick={props.onClick}>      
              <span className="dollar-sign">$</span>   
              </UITextInput>     
          </div>
      </div>
  );
}